export enum MessageOrigin {
  AUTOMATIC = 'AUTOMATIC',
  MANUAL = 'MANUAL',
}
